import { Loader } from "@mantine/core";
import { Navigate } from "react-router-dom";
import { useAuth } from "../hooks/core/useAuth";
import { useInactivityLogout } from "../hooks/core/useInactivityLogout";

export function ProtectedRoute({ children }) {
  const { user, staffProfile, isLoading, error } = useAuth();
  useInactivityLogout();

  // Always show loading state while checking auth
  if (isLoading) {
    return (
      <div
        style={{
          position: "fixed",
          top: "50%",
          left: "50%",
          transform: "translate(-50%, -50%)",
          fontSize: "1.2em",
        }}
      >
        <Loader color="blue" size="xl" type="bars" />
      </div>
    );
  }

  // Only redirect if fully loaded and no auth
  if (!user || !staffProfile) {
    console.log("Access denied:", {
      hasUser: !!user,
      userId: user?.uid,
      hasStaffProfile: !!staffProfile,
      staffProfileError: error?.message,
      currentPath: window.location.pathname,
    });

    // If user exists but staff profile doesn't, log more details
    if (user && !staffProfile) {
      console.error("User authenticated but staff profile missing:", {
        userId: user.uid,
        email: user.email,
        expectedPath: `/staff/${user.uid}`,
      });
      console.error("Check Firestore to ensure staff document exists at /staff/" + user.uid);
    }

    // Don't store path if already on auth page
    if (window.location.pathname !== "/auth") {
      // Store full URL including search params and hash
      const returnTo = window.location.pathname + window.location.search + window.location.hash;
      sessionStorage.setItem("returnTo", returnTo);
    }

    return <Navigate to="/auth" state={{ from: window.location.pathname }} />;
  }

  return children;
}
